import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent implements OnInit {

    @Input() readonly: boolean;
    @Input() isError: boolean;

    _phoneValue: string;
    myMask: string;
    showMaskTyped: boolean;
    myPlaceholder: string;
    get phoneValue(): string {
        return this._phoneValue;
    }
    @Input() set phoneValue(value: string) {
        this._phoneValue = value;
        this.phoneValueChange.emit(this._phoneValue);
        this.phoneValueWithRegionChange.emit(this.phoneValueWithRegion);
    }
    @Output() phoneValueChange = new EventEmitter<string>();


    get phoneValueWithRegion(): string {
        return `7${this._phoneValue}`;
    }
    @Input() set phoneValueWithRegion(value: string) {
        if (value)
            this.phoneValue = value.substring(1);
    }
    @Output() phoneValueWithRegionChange = new EventEmitter<string>();

    constructor() {
        this.myMask = null;
        this.showMaskTyped = false;
    }

    ngOnInit(): void {
        this.myPlaceholder = "+7 (___) ___-__-__";
    }
    MaskIn() {
        this.myMask = "(XXX) XXX-XX-XX";
        this.showMaskTyped = true;
        this.myPlaceholder = null;
    }
    MaskOut() {
        if (!this.phoneValue) {
            this.myMask = null;
            this.showMaskTyped = false;
            this.myPlaceholder = "+7 (___) ___-__-__";
        }        
    }
}
